"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-use-before-define */
const simpleformula_form_1 = __importDefault(require("./simpleformula.form"));
const Field_1 = __importDefault(require("../../_classes/field/Field"));
const lodash_1 = __importDefault(require("lodash"));
const js_datepicker_1 = __importDefault(require("js-datepicker"));
const moment_1 = __importDefault(require("moment"));
const choices_js_1 = __importDefault(require("@ariform/choices.js"));
const AriFormUtils = __importStar(require("../../../utils/utils"));
//import dxTagBox from 'devextreme/ui/tag_box';
// import component from '../../templates/bootstrap/component';
// import { debug } from 'webpack';
// import AriForm from '../../../AriForm';
/**
 * Here we will derive from the base component which all Ari.Form form components derive from.
 * @param component
 * @param options
 * @param data
 * @class
 */
class SimpleFormulaComponent extends Field_1.default {
    constructor(component, options, data) {
        super(component, options, data);
        this.dataName = '';
        this.formulaListFlat = [];
        this.dataFormulaItem = {};
        this.formulaData = [];
        this.formulaArr = {};
        this.formulaParamItem = {};
        this.formulaParam = [];
        this.debouncedFunction = lodash_1.default.debounce((v) => {
            const newResult = this.filterConditions(this.formulaListFlat, v);
            this.refs[`${this.component.key}-formulaList`].innerHTML = this.renderSelectGroup(newResult).join('');
            this.getFormulaDitail();
        });
    }
    static schema(...extend) {
        return Field_1.default.schema({
            type: 'simpleFormula',
            label: 'Simple FormulaComponent',
            dataSrc: 'aripost',
            dataSourcePath: 'dataSource',
            defaultRulePath: 'rule',
            displayInfo: true,
            defaultRule: '',
            formulaDataSource: '',
            align: 'justify-content-start',
            action: 'event'
        }, ...extend);
    }
    get defaultSchema() {
        return SimpleFormulaComponent.schema();
    }
    get emptyValue() {
        return this.getValue();
    }
    get inputInfo() {
        const info = super.inputInfo;
        return info;
    }
    get selectItem() {
        const selectItem = this.selectItemArr;
        return selectItem;
    }
    render() {
        var view = `<div class="${this.component.key}-custom-wraper-simple-formula">
                <div class="${this.component.key}-custom-simple-formula ari-flex ari-gap-7 ari-w-full ari-h-[500px] ari-overflow-hidden ">
                <div class="${this.component.key}-custom-simple-formula__list ari-w-1/3">
                    <div class="${this.component.key}-custom-simple-formula__list-header ari-bg-gray-200 ari-p-3">
                        <div class="${this.component.key}-custom-simple-formula__list-header-title ari-text-gray-500  ari-uppercase ari-font-semibold">${AriFormUtils.getLangText('Condition type')}</div>
                        
                    </div>
                    <div class="p-4">
                        <div class="${this.component.key}-custom-simple-formula__list-search ari-border ari-border-gray-300 ari-py-[6px] ari-px-3 ari-flex ari-gap-2 ari-items-center ari-mb-4">
                                <i class="fa fa-search ari-text-[#667085]" aria-hidden="true"></i>   
                                <input ref="${this.component.key}-input-search" class="ari-w-full focus-visible:ari-outline-none ari-bg-transparent" placeholder="${AriFormUtils.getLangText('Search condition')}"/>
                        </div>
                        <div  ref="${this.component.key}-formulaList" class="custom-simple-formula__list-body ari-pb-10 ari-max-h-[400px] ari-overflow-auto">
                        </div>
                    </div>
                </div>
                <div class="${this.component.key}-custom-simple-formula__items ari-w-2/3">
                <div class="${this.component.key}-custom-simple-formula__items-header  ari-bg-gray-200 ari-p-3">
                    <div class="${this.component.key}-custom-simple-formula__items-header-title ari-text-gray-500  ari-uppercase ari-font-semibold">${AriFormUtils.getLangText('Saved conditions')}</div>
                </div>
                <div ref="${this.component.key}-formula-grid" class="custom-simple-formula__items-body p-4">
                    ${AriFormUtils.getLangText('Not saved any condition yet')}
                </div>
                </div>
            </div>
            <div class="modal fade ${this.component.key}-modal" id="modal-${this.component.key}" tabindex="-1"  aria-hidden="true">
            <div class="modal-dialog ${this.component.key}-modal-dialog">
            <div class="modal-content ${this.component.key}-modal-content">
              <div class="modal-header ${this.component.key}-modal-header">
                <h5 class="modal-title ${this.component.key}-modal-title">Modal title</h5>
                <button type="button" class="close ${this.component.key}-modal-close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body ${this.component.key}-modal-body">
                ...
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary ${this.component.key}-custom-close-modal-formula-detail" data-dismiss="modal">${AriFormUtils.getLangText('close')}</button>
                <button type="button" class="btn btn-primary ${this.component.key}-custom-add-modal-formula-detail">${AriFormUtils.getLangText('savecondition')}</button>
              </div>
            </div>
          </div>
            </div>
        </div>`;
        return super.render(view);
    }
    renderLoading() {
        return `<div class="${this.component.key}-auto-select-loading p-3"><i class="fa fa-refresh" aria-hidden="true"></i></div>`;
    }
    setDataName(value) {
        this.dataName = value;
    }
    setValue(value, flags = {}) {
        super.setValue(value, flags);
    }
    getValue() {
        return this.value;
    }
    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     * @param element
     * @returns {Promise}
     */
    renderSelectItems(data) {
        // data-toggle="modal" data-target="#modal-${this.component.key}"
        return data.map((value) => {
            return `
                <div  class="${this.component.key}-custom-simple-items__item ari-flex ari-items-center ari-justify-between ari-pl-4 ari-py-3">
                    <span class="ari-font-normal ari-text-gray-700 ">${AriFormUtils.getLangText(value.conditionName)}</span>
                    <div data-id="${value.conditionKey}" data-name="${value.conditionName}" ref="${this.component.key}-detail-control"  class="${this.component.key}-custom-simple-items__item-icon ari-w-5 ari-h-5 ari-rounded-full ari-flex ari-items-center ari-justify-center ari-bg-gray-100 ari-cursor-pointer">
                        <span class="${this.component.key}-custom-plus-icon ari-text-gray-500 ari-text-xs">&#10010;</span>
                    </div>
                    <div class="lds-spinner custom-spinner ari-hidden ${this.component.key}-custom-spner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                </div>
            `;
        });
    }
    renderSelectGroup(data) {
        return data.map((value) => {
            return `
                <div ref="${this.component.key}-list-items-header" class="custom-simple-fomula-list__items ">
                   <div class="ari-flex ari-gap-[6px]   ari-items-center">
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                    <span class="ari-text-gray-900 ari-font-semibold">${AriFormUtils.getLangText(value.group)}</span>
                   </div>
                    ${this.renderSelectItems(value.items).join('')}
                </div>
            `;
        });
    }
    filterConditions(data, userInput) {
        // Hàm kiểm tra chuỗi con xuất hiện theo thứ tự và liền kề
        const isSubstring = (str, sub) => {
            return str.includes(sub);
        };
        return data.map(group => {
            const filteredItems = group.items.filter(item => {
                return isSubstring(item.conditionName.toLowerCase(), userInput.toLowerCase());
            });
            if (filteredItems.length > 0) {
                return Object.assign(Object.assign({}, group), { items: filteredItems });
            }
            return null;
        }).filter(group => group !== null);
    }
    renderOperator(data, result) {
        setTimeout(() => {
            const html = document.querySelector(`.${this.component.key}-custom-formula-oparator-select`);
            if (html) {
                new choices_js_1.default(html, {
                    removeItemButton: false,
                    searchEnabled: false,
                    renderChoiceLimit: -1,
                    maxItemCount: -1,
                });
                html.addEventListener('change', (e) => {
                    this.dataFormulaItem['operatorData'] = e.detail.value;
                    this.dataFormulaItem.formulaData[1] = e.detail.value;
                    this.dataFormulaItem['formulaName'][1] = e.detail.value;
                    document.querySelector(`.${this.component.key}-custom-formula-detail-value`).innerHTML = this.renderConditionValue(result);
                });
            }
        }, 300);
        return data.map((value) => {
            return `<option value="${value.key}">
            ${AriFormUtils.getLangText(value.name)}
          </option class="ari-w-full">`;
        });
    }
    renderOptionItems(data, key, value) {
        return data ? data.map((v) => {
            return `<option class="ari-w-full" value="${v[key]}">${AriFormUtils.getLangText(v[value])}</option>`;
        }) : '<div></div>';
    }
    renderInput(dataType, data, option) {
        if (option) {
            this.dataFormulaItem['param'] = Object.assign(Object.assign({}, this.dataFormulaItem.param), { [data.ConditionKey]: '' });
        }
        else {
            if (this.dataFormulaItem.operatorData === 'in' || this.dataFormulaItem.operatorData === 'between') {
                this.dataFormulaItem['formulaData'][2] = [];
                this.dataFormulaItem['formulaName'][2] = [];
            }
            else {
                this.dataFormulaItem['formulaData'][2] = '';
                this.dataFormulaItem['formulaName'][2] = '';
            }
        }
        setTimeout(() => {
            let values = [];
            if (option) {
                const element = document.querySelectorAll(`.${this.component.key}-custom-formula-input-option-value`);
                if (element) {
                    element.addEventListener('input', (e) => {
                        this.dataFormulaItem['param'] = Object.assign(Object.assign({}, this.dataFormulaItem.param), { [data.ConditionKey]: dataType === 'number' && e.target.value !== '' ? parseFloat(e.target.value) : e.target.value });
                    });
                }
            }
            else {
                if (this.dataFormulaItem.operatorData === 'in') {
                    const html = document.querySelector(`.${this.component.key}-custom-formula-input-value:not(.custom-formula-input-option-value)`);
                    new choices_js_1.default(html, {
                        removeItemButton: true,
                        addItemText: (value) => {
                            return `${AriFormUtils.getLangText('Press Enter to add')} <b>"${value}"</b>`;
                        },
                        customAddItemText: dataType === 'number' ? `${AriFormUtils.getLangText('Only input number')}` : `${AriFormUtils.getLangText('Only values matching specific conditions can be added')}`,
                        duplicateItemsAllowed: false,
                        addItemFilter: (value) => {
                            return dataType === 'number' ? /^\d+$/.test(value) : true;
                        }
                    });
                    html.addEventListener('addItem', (e) => {
                        if (document.querySelector(`.${this.component.key}-custom-formula-condition-value-error:not(ari-hidden)`) && e.target.value !== '') {
                            document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.add('ari-hidden');
                            document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.remove('ari-block');
                        }
                        if (e.target.value === '') {
                            document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.remove('ari-hidden');
                            document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.add('ari-block');
                        }
                        values.push(dataType === 'number' && e.detail.value !== '' ? parseFloat(e.detail.value) : e.detail.value);
                        this.dataFormulaItem['formulaData'][2] = values;
                        this.dataFormulaItem['formulaName'][2] = values;
                    });
                    html.addEventListener('removeItem', (e) => {
                        values = this.dataFormulaItem['formulaData'][2].filter((v) => v !== e.detail.value);
                        this.dataFormulaItem['formulaData'][2] = values;
                        this.dataFormulaItem['formulaName'][2] = values;
                    });
                }
                else if (this.dataFormulaItem.operatorData === 'between') {
                    const html = document.querySelectorAll(`.${this.component.key}-custom-formula-input-value:not(.custom-formula-input-option-value)`);
                    html.forEach((v, i) => {
                        v.addEventListener('input', (e) => {
                            if (document.querySelector(`.${this.component.key}-custom-formula-condition-value-error:not(ari-hidden)`) && e.target.value !== '') {
                                document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.add('ari-hidden');
                                document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.remove('ari-block');
                            }
                            if (e.target.value === '') {
                                document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.remove('ari-hidden');
                                document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.add('ari-block');
                            }
                            values[i] = dataType === 'number' && e.target.value !== '' ? parseFloat(e.target.value) : e.target.value;
                            this.dataFormulaItem['formulaData'][2] = values;
                            this.dataFormulaItem['formulaName'][2] = values;
                        });
                    });
                }
                else {
                    const html = document.querySelector(`.${this.component.key}-custom-formula-input-value:not(.custom-formula-input-option-value)`);
                    if (html) {
                        html.addEventListener('input', (e) => {
                            if (document.querySelector(`.${this.component.key}-custom-formula-condition-value-error:not(ari-hidden)`) && e.target.value !== '') {
                                document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.add('ari-hidden');
                                document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.remove('ari-block');
                            }
                            if (e.target.value === '') {
                                document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.remove('ari-hidden');
                                document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.add('ari-block');
                            }
                            this.dataFormulaItem['formulaData'][2] = dataType === 'number' && e.target.value !== '' ? parseFloat(e.target.value) : e.target.value;
                            this.dataFormulaItem['formulaName'][2] = dataType === 'number' && e.target.value !== '' ? parseFloat(e.target.value) : e.target.value;
                        });
                    }
                }
            }
        }, 300);
        const input = `<input type="${this.dataFormulaItem.operatorData === 'in' ? 'txt' : dataType}" inputmode= "${dataType === 'number' ? 'numeric' : 'text'}" placeholder="${AriFormUtils.getLangText('Input value')}" class="${this.component.key}-custom-formula-input-value ari-flex-1 ari-w-full ari-border ari-border-gray-300 focus-visible:ari-outline-none ari-bg-transparent ari-rounded ari-p-2 ${option ? `${this.component.key}-custom-formula-input-option-value` : ''}" />`;
        if (this.dataFormulaItem.operatorData === 'between') {
            return `
                <div class="ari-w-full ari-flex ari-items-center ari-flex-col ari-gap-y-2">
                    ${input}
                    ${input}
                </div>`;
        }
        else {
            return input;
        }
    }
    renderSelect(data, option) {
        var _a, _b, _c;
        if (option) {
            this.dataFormulaItem['param'] = Object.assign(Object.assign({}, this.dataFormulaItem.param), { [data.ConditionKey]: data.Lookup.dataSource[0][data.Lookup.valueExpr] });
        }
        else {
            if (this.dataFormulaItem.operatorData === 'in') {
                this.dataFormulaItem['formulaData'][2] = [];
                this.dataFormulaItem['formulaName'][2] = [];
            }
            else if (this.dataFormulaItem.operatorData === 'between') {
                this.dataFormulaItem['formulaData'][2] = [data.Lookup.dataSource[0][data.Lookup.valueExpr], data.Lookup.dataSource[0][data.Lookup.valueExpr]];
                this.dataFormulaItem['formulaName'][2] = [data.Lookup.dataSource[0][data.Lookup.displayExpr], data.Lookup.dataSource[0][data.Lookup.displayExpr]];
            }
            else {
                this.dataFormulaItem['formulaData'][2] = data.Lookup.dataSource[0][data.Lookup.valueExpr];
                this.dataFormulaItem['formulaName'][2] = data.Lookup.dataSource[0][data.Lookup.displayExpr];
            }
        }
        setTimeout(() => {
            let html = '';
            if (option) {
                html = document.querySelectorAll(`.${this.component.key}-custom-formula-choise-value`);
            }
            else {
                html = document.querySelectorAll(`.${this.component.key}-custom-formula-choise-value:not(.custom-formula-input-option-select)`);
            }
            if (html) {
                let values = [];
                let valueNames = [];
                html.forEach((v, i) => {
                    new choices_js_1.default(v, {
                        removeItemButton: (this.dataFormulaItem.operatorData === 'in' && !option) ? true : false,
                        searchEnabled: true,
                        renderChoiceLimit: -1,
                        maxItemCount: -1,
                    });
                    v.addEventListener('addItem', (e) => {
                        if (option) {
                            this.dataFormulaItem.param = Object.assign(Object.assign({}, this.dataFormulaItem.param), { [data.ConditionKey]: e.detail.value });
                        }
                        else {
                            if (this.dataFormulaItem.operatorData === 'in') {
                                values.push(data.DataType === 'number' ? parseFloat(e.detail.value) : e.detail.value);
                                valueNames.push(e.detail.label);
                                this.dataFormulaItem['formulaData'][2] = values;
                                this.dataFormulaItem['formulaName'][2] = valueNames;
                            }
                            else if (this.dataFormulaItem.operatorData === 'between') {
                                const obj = this.dataFormulaItem['formulaData'][2];
                                const objName = this.dataFormulaItem['formulaName'][2];
                                obj[i] = data.DataType === 'number' ? parseFloat(e.detail.value) : e.detail.value;
                                objName[i] = e.detail.label;
                                this.dataFormulaItem['formulaData'][2] = obj;
                                this.dataFormulaItem['formulaName'][2] = objName;
                            }
                            else {
                                this.dataFormulaItem['formulaData'][2] = data.DataType === 'number' && e.detail.value !== '' ? parseFloat(e.detail.value) : e.detail.value;
                                this.dataFormulaItem['formulaName'][2] = e.detail.label;
                            }
                        }
                    });
                    v.addEventListener('removeItem', (e) => {
                        if (this.dataFormulaItem.operatorData === 'in' && !option) {
                            values = this.dataFormulaItem['formulaData'][2].filter((v) => v !== e.detail.value);
                            valueNames = this.dataFormulaItem['formulaName'][2].filter((v) => v !== e.detail.label);
                            this.dataFormulaItem['formulaData'][2] = values;
                            this.dataFormulaItem['formulaName'][2] = valueNames;
                        }
                    });
                });
            }
        }, 300);
        const selectElement = `
            <select ${(this.dataFormulaItem.operatorData === 'in' && !option) ? 'multiple' : ''} class=" ${this.component.key}-custom-formula-choise-value ari-flex-1 ari-w-full ari-border ari-border-gray-300 focus-visible:ari-outline-none ari-bg-transparent ari-rounded ari-p-2 ${option ? 'custom-formula-input-option-select' : ''}">
                ${Object.keys(data.Lookup).length > 0 && this.renderOptionItems((_a = data === null || data === void 0 ? void 0 : data.Lookup) === null || _a === void 0 ? void 0 : _a.dataSource, (_b = data === null || data === void 0 ? void 0 : data.Lookup) === null || _b === void 0 ? void 0 : _b.valueExpr, (_c = data === null || data === void 0 ? void 0 : data.Lookup) === null || _c === void 0 ? void 0 : _c.displayExpr).join('')} 
            </select>`;
        if (this.dataFormulaItem.operatorData === 'between' && !option) {
            return `
                <div class="ari-w-full ari-flex ari-items-center ari-flex-col ari-gap-y-2">
                    ${selectElement}
                    ${selectElement}
                </div>`;
        }
        else {
            return selectElement;
        }
    }
    renderDatepicker(data, option) {
        if (option) {
            this.dataFormulaItem['param'] = Object.assign(Object.assign({}, this.dataFormulaItem.param), { [data.ConditionKey]: '' });
        }
        else {
            if (this.dataFormulaItem.operatorData === 'between') {
                this.dataFormulaItem['formulaData'][2] = [];
                this.dataFormulaItem['formulaName'][2] = [];
            }
            else {
                this.dataFormulaItem['formulaData'][2] = '';
                this.dataFormulaItem['formulaName'][2] = '';
            }
        }
        setTimeout(() => {
            let element = '';
            if (option) {
                element = document.querySelectorAll(`.${this.component.key}-custom-formula-datpicker-option-wraper`);
            }
            else {
                element = document.querySelectorAll(`.${this.component.key}-custom-formula-datpicker-wraper:not(.${this.component.key}-custom-formula-datpicker-option-wraper)`);
            }
            const values = [];
            const valueNames = [];
            element.forEach((v, i) => {
                (0, js_datepicker_1.default)(v, {
                    onSelect: (instance, date) => {
                        const dateSelect = (0, moment_1.default)(date).format('DD/MM/YYYY');
                        const momentDate = (0, moment_1.default)(date, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (Z)');
                        v.querySelector(`.${this.component.key}-custom-formula-detail-datpicker`).innerHTML = `<span class="${this.component.key}-custom-date-value">${dateSelect}</span>`;
                        if (option) {
                            this.dataFormulaItem['param'] = Object.assign(Object.assign({}, this.dataFormulaItem.param), { [data.ConditionKey]: momentDate.toISOString() });
                        }
                        else {
                            if (this.dataFormulaItem.operatorData === 'between') {
                                values[i] = momentDate.toISOString();
                                valueNames[i] = dateSelect;
                                this.dataFormulaItem['formulaData'][2] = values;
                                this.dataFormulaItem['formulaName'][2] = valueNames;
                            }
                            else {
                                this.dataFormulaItem['formulaData'][2] = momentDate.toISOString();
                                this.dataFormulaItem['formulaName'][2] = dateSelect;
                            }
                        }
                    }
                });
            });
        }, 500);
        const html = `
            <div class="ari-relative ari-min-h-[40px] ${this.component.key}-custom-formula-datpicker-wraper ari-flex-1 ari-w-full ari-border ari-border-gray-300 ari-rounded ari-p-2 ${option ? `${this.component.key}-custom-formula-datpicker-option-wraper` : ''}">
                <div type="text" class="${this.component.key}-custom-formula-detail-datpicker ari-w-fit"><span class="ari-text-gray-400">${AriFormUtils.getLangText('Choose date')}</span></div>
                <i class=" ${this.component.key}-custom-formula-icon-calandar ari-z-40 fa fa-calendar ari-absolute ari-right-1 ari-bottom-1/2 ari-translate-y-1/2" aria-hidden="true"></i>
            </div>
        `;
        if (this.dataFormulaItem.operatorData === 'between') {
            return `
            <div class="ari-w-full ari-flex ari-items-center ari-flex-col ari-gap-y-2">
                    ${html}
                    ${html}
                </div>
            `;
        }
        else {
            return html;
        }
    }
    renderBoolen(data, option) {
        if (option) {
            this.dataFormulaItem['param'] = Object.assign(Object.assign({}, this.dataFormulaItem.param), { [data.ConditionKey]: true });
        }
        else {
            this.dataFormulaItem['formulaData'][2] = true;
            this.dataFormulaItem['formulaName'][2] = 'true';
        }
        setTimeout(() => {
            let html = '';
            if (option) {
                html = document.querySelector(`.${this.component.key}-custom-formula-select-option-boolean`);
            }
            else {
                html = document.querySelector(`.${this.component.key}-custom-formula-select-boolean:not(.${this.component.key}-custom-formula-select-option-boolean)`);
            }
            new choices_js_1.default(html, {
                removeItemButton: false,
                searchEnabled: false,
                renderChoiceLimit: -1,
                maxItemCount: -1,
            });
            html.addEventListener('change', (e) => {
                if (option) {
                    this.dataFormulaItem['param'] = Object.assign(Object.assign({}, this.dataFormulaItem.param), { [data.ConditionKey]: e.detail.value });
                }
                else {
                    this.dataFormulaItem.formulaData[2] = e.detail.value && JSON.parse(e.detail.value);
                    this.dataFormulaItem['formulaName'][2] = e.detail.value;
                }
            });
        }, 300);
        return `<select class="${this.component.key}-custom-formula-select-boolean ari-flex-1 ari-w-full ari-border ari-border-gray-300 focus-visible:ari-outline-none ari-bg-transparent ari-rounded ari-p-2 ${option ? '${this.component.key}-custom-formula-select-option-boolean' : ''}">
            <option class="ari-w-full" value="true">${AriFormUtils.getLangText('Yes')}</option>
            <option class="ari-w-full" value ="false">${AriFormUtils.getLangText('No')}</option>
        </select>`;
    }
    renderConditionValue(data, option) {
        switch (data.ControlType) {
            case 'CBB':
                if (Object.keys(data.Lookup ? data.Lookup : {}).length === 0) {
                    return this.renderInput(data.DataType, data, option);
                }
                else {
                    return this.renderSelect(data, option);
                }
            case 'TXT':
                if (data.DataType === 'boolean') {
                    return this.renderBoolen(data, option);
                }
                else if (data.DataType === 'date') {
                    return this.renderDatepicker(data, option);
                }
                else {
                    return this.renderInput(data.DataType, data, option);
                }
            // eslint-disable-next-line no-fallthrough
            default:
                return '';
        }
    }
    renderOperatoHTML(data) {
        return `
        <div class="${this.component.key}-custom-formula-content-item ari-flex ari-items-center ari-gap-1 ari-mb-5">
        <span class="ari-font-medium ari-text-sm ari-text-gray-600 ari-w-36 ari-block">${AriFormUtils.getLangText('Operator')}</span>
        <div class="ari-flex-1 ari-w-full ">
            <select ref="${this.component.key}-formula-operator" class="${this.component.key}-custom-formula-oparator-select   focus-visible:ari-outline-none ari-bg-transparent ari-rounded ari-border ari-p-2 ari-flex-1 ari-w-full">
            ${this.renderOperator(data.Operator, data).join('')}
            </select>
        </div>
        </div>
        `;
    }
    renderOption(data) {
        return data.map((v) => {
            return `
                <div class="${this.component.key}-custom-formula-content-item ari-flex ari-items-center ari-gap-1 ari-mb-5">
                    <span class="ari-font-medium ari-text-sm ari-text-gray-600 ari-w-36 ari-block">${AriFormUtils.getLangText(v.DisplayName)} </span>
                    <div class="${this.component.key}-custom-formula-detail-value ari-flex-1">
                        ${this.renderConditionValue(v, 'param')}
                    </div>
                </div>
            `;
        });
    }
    renderPopupDetailFomulaCBB(data) {
        return `
            <div class="${this.component.key}-custom-formula-content">
                <div class="${this.component.key}-custom-formula-content-item ari-gap-1 ari-mb-5">
                    <div class="ari-flex ari-items-center">
                        <span class="ari-font-medium ari-text-sm ari-text-gray-600 ari-w-36 ari-block">${AriFormUtils.getLangText('Condition name')}</span>
                        <input class="${this.component.key}-custom-formula-condition-name ari-flex-1 ari-border ari-border-gray-300 focus-visible:ari-outline-none ari-bg-transparent ari-rounded ari-p-2" placeholder= "${AriFormUtils.getLangText('Input name')}" />
                    </div>
                    <span class="${this.component.key}-custom-formula-condition-name-error ari-text-right ari-mt-2 ari-text-red-700 ari-text-xs ari-hidden">${AriFormUtils.getLangText('Condition name not empty')}</span>
                </div>
                ${data.DataType !== 'boolean' ? this.renderOperatoHTML(data) : ''}
                <div class="${this.component.key}-custom-formula-content-item  ari-gap-1 ari-mb-5">
                    <div class="ari-flex ari-items-center">
                        <span class="ari-font-medium ari-text-sm ari-text-gray-600 ari-w-36 ari-block">${AriFormUtils.getLangText(data.DisplayName)} </span>
                        <div class="${this.component.key}-custom-formula-detail-value ari-flex-1">
                            ${this.renderConditionValue(data)}
                        </div>
                    </div>
                    <span class="${this.component.key}-custom-formula-condition-value-error ari-text-right ari-mt-2 ari-text-red-700 ari-text-xs ari-hidden">${AriFormUtils.getLangText(data.DisplayName)} ${AriFormUtils.getLangText('Not empty')}</span>
                </div>
                ${data.Param.length > 0 ? this.renderOption(data.Param) : ''}
            </div>
        `;
    }
    renderItemGrid() {
        return this.formulaData.map((v) => {
            const formulaName = v.formulaName[0];
            let formula;
            if (v.operatorData === 'between') {
                formula = `from ${v.formulaName[2][0]} to ${v.formulaName[2][1]}`;
            }
            else {
                formula = v.formulaName[2];
            }
            return `
            <tr class="ari-border-b ari-border-[#EAECF0]">
                <td class="ari-py-4 ari-px-1 ari-pl-4 ari-text-sm">${AriFormUtils.getLangText(v.conditionName)}</td>
                <td class="ari-py-4 ari-px-1 ari-text-sm">${AriFormUtils.getLangText(formulaName)}</td>
                <td class="ari-py-4 ari-px-1 ari-text-sm">${AriFormUtils.getLangText(v.formulaName[1])} ${AriFormUtils.getLangText(formula)}</td>
                <td class="ari-py-4 ari-px-1 ari-pr-4"><i class="${this.component.key}-custom-remove-formula ari-text-[#EA614E] fa fa-trash-o"  data-id="${v.expressionId}" aria-hidden="true"></i></td>
            </tr>
            `;
        });
    }
    setFormula() {
        const fomulaString = [];
        this.formulaData.map((v, i, a) => {
            fomulaString.push(v.formulaData);
            if (i < a.length - 1) {
                fomulaString.push('and');
            }
        });
        this.formulaArr = {
            formula: fomulaString,
            formulaData: this.formulaData,
        };
        this.setValue(this.formulaArr);
    }
    getIndexByOrder(order) {
        return (order - 1) * 2;
    }
    renderGrid() {
        setTimeout(() => {
            document.querySelectorAll(`.${this.component.key}-custom-remove-formula`).forEach((v) => {
                v.addEventListener('click', () => {
                    const id = v.getAttribute('data-id');
                    const newData = this.formulaData.filter((v) => v.expressionId !== parseInt(id));
                    const a = newData.map((v, i) => {
                        return Object.assign(Object.assign({}, v), { expressionId: i, index: newData.length === 0 ? 0 : this.getIndexByOrder(i + 1) });
                    });
                    this.formulaData = a;
                    this.setFormula();
                    this.refs[`${this.component.key}-formula-grid`].innerHTML = this.renderGrid();
                });
            });
        }, 300);
        const table = `
        <table class="ari-w-full ari-border-l ari-border-r ${this.component.key}-table">
            <tr class="ari-bg-[#EAECF0] ari-border-b ari-border-[#EAECF0]">
                <th class=" ari-py-3 ari-px-1 ari-pl-4 ari-text-[13px] ari-text-gray-500">${AriFormUtils.getLangText('Condition name')}</th>
                <th class=" ari-p-3 ari-px-1 ari-text-[13px] ari-text-gray-500">${AriFormUtils.getLangText('Condition type')}</th>
                <th class=" ari-p-3 ari-px-1 ari-text-[13px] ari-text-gray-500">${AriFormUtils.getLangText('Formula')}</th>
                <th class=" ari-p-3 ari-px-1"></th>
            </tr>
           ${this.renderItemGrid().join('')}
        </table>
    `;
        const empty = `
    ${AriFormUtils.getLangText('notsavedanyconditionyet')}
    `;
        return this.formulaData.length > 0 ? table : empty;
    }
    getFormulaDitail() {
        document.querySelectorAll(`.${this.component.key}-custom-simple-items__item-icon`).forEach((value) => {
            value.addEventListener('click', (e) => {
                // document.querySelector(`#modal-${this.component.key} .modal-body`).appendChild([this.renderDatepicker()[0]]);
                document.querySelectorAll(`.${this.component.key}-custom-simple-items__item-icon`).forEach(v => {
                    v.classList.add('ari-hidden');
                });
                value.nextElementSibling.classList.remove('ari-hidden');
                var args = this.evalContext(args);
                const dataName = e.currentTarget.getAttribute('data-name');
                args.form = this.root;
                const conditionKey = e.currentTarget.getAttribute('data-id');
                const aribodyForSearch = this.component.aribody.map((v) => {
                    v.value = conditionKey;
                    return v;
                });
                this.emit('requestAri', {
                    com: this.component,
                    url: this.interpolate(this.component.formulacontrol),
                    aribody: aribodyForSearch,
                    resultType: null,
                    script: (result) => {
                        this.dataFormulaItem = {
                            conditionName: '',
                            operatorData: result.Operator[0].key,
                            formulaData: [conditionKey, result.Operator[0].key],
                            formulaName: [dataName, result.Operator[0].name]
                        };
                        const componentKey = this.component.key;
                        document.querySelector(`.${this.component.key}-modal-title`).innerHTML = dataName;
                        document.querySelector(`.${this.component.key}-modal-body`).innerHTML = this.renderPopupDetailFomulaCBB(result);
                        // eslint-disable-next-line no-undef
                        // $(`#modal-${this.component.key}`).modal('show');
                        const removeModal = () => {
                            document.querySelector(`#modal-${this.component.key}`).classList.remove('d-block', 'show', 'ari-bg-black/50');
                            document.querySelector(`#modal-${componentKey} .${componentKey}-modal-title`).innerHTML = '...';
                            // eslint-disable-next-line no-undef
                            document.querySelector(`#modal-${componentKey} .${componentKey}-modal-body`).innerHTML = '...';
                        };
                        document.querySelector(`#modal-${this.component.key}`).classList.add('d-block', 'show', 'ari-bg-black/50');
                        document.querySelectorAll(`.${this.component.key}-custom-simple-items__item-icon`).forEach(v => {
                            v.classList.remove('ari-hidden');
                        });
                        value.nextElementSibling.classList.add('ari-hidden');
                        setTimeout(() => {
                            const conditionName = document.querySelector(`.${this.component.key}-custom-formula-condition-name`);
                            if (conditionName) {
                                conditionName.addEventListener('input', (e) => {
                                    if (e.target.value === '') {
                                        document.querySelector(`.${this.component.key}-custom-formula-condition-name-error`).classList.remove('ari-hidden');
                                        document.querySelector(`.${this.component.key}-custom-formula-condition-name-error`).classList.add('ari-block');
                                    }
                                    if (document.querySelector(`.${this.component.key}-custom-formula-condition-name-error:not(ari-hidden)`) && e.target.value !== '') {
                                        document.querySelector(`.${this.component.key}-custom-formula-condition-name-error`).classList.add('ari-hidden');
                                        document.querySelector(`.${this.component.key}-custom-formula-condition-name-error`).classList.remove('ari-block');
                                    }
                                    this.dataFormulaItem['conditionName'] = e.target.value;
                                });
                            }
                            // eslint-disable-next-line no-undef
                            const modal = document.querySelector(`#modal-${this.component.key}`);
                            modal.addEventListener('click', (e) => {
                                if (e.target === modal) {
                                    removeModal();
                                }
                            });
                            document.querySelector(`.${this.component.key}-custom-close-modal-formula-detail`).addEventListener('click', () => {
                                removeModal();
                            });
                            document.querySelector(`.${this.component.key}-modal-close`).addEventListener('click', () => {
                                removeModal();
                            });
                            // eslint-disable-next-line no-undef
                            const handleAddItemClick = () => {
                                if (this.dataFormulaItem.conditionName === '') {
                                    document.querySelector(`.${this.component.key}-custom-formula-condition-name-error`).classList.remove('ari-hidden');
                                    document.querySelector(`.${this.component.key}-custom-formula-condition-name-error`).classList.add('ari-block');
                                    return;
                                }
                                if ((this.dataFormulaItem.formulaData[2].length === 0) || (this.dataFormulaItem.operatorData === 'between' && this.dataFormulaItem.formulaData[2].length < 2)) {
                                    document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.remove('ari-hidden');
                                    document.querySelector(`.${this.component.key}-custom-formula-condition-value-error`).classList.add('ari-block');
                                    return;
                                }
                                this.formulaData.push(Object.assign(Object.assign({}, this.dataFormulaItem), { expressionId: this.formulaData.length === 0 ? 0 : this.formulaData.length, index: this.formulaData.length === 0 ? 0 : this.getIndexByOrder(this.formulaData.length + 1) }));
                                this.setFormula();
                                this.refs[`${this.component.key}-formula-grid`].innerHTML = this.renderGrid();
                                // eslint-disable-next-line no-undef
                                removeModal();
                                // Gỡ bỏ sự kiện sau khi thực hiện
                                document.querySelector(`.${this.component.key}-custom-add-modal-formula-detail`).removeEventListener('click', handleAddItemClick);
                            };
                            // Thêm sự kiện với handleAddItemClick
                            document.querySelector(`.${this.component.key}-custom-add-modal-formula-detail`).addEventListener('click', handleAddItemClick);
                        }, 300);
                    },
                    scriptFail: (e) => {
                        AriFormUtils.toasterror('error', e.ErrorDesc);
                        document.querySelectorAll(`.${this.component.key}-custom-simple-items__item-icon`).forEach(v => {
                            v.classList.remove('ari-hidden');
                        });
                        value.nextElementSibling.classList.add('ari-hidden');
                    },
                    args: args
                });
            });
        });
    }
    bindData(data) {
        this.setValue(data);
        this.formulaData = data.formulaData;
        this.refs[`${this.component.key}-formula-grid`].innerHTML = this.renderGrid();
    }
    attach(element) {
        var refs = {};
        refs[`${this.component.key}-formulaList`] = 'single';
        refs[`${this.component.key}-input-search`] = 'single';
        refs[`${this.component.key}-formula-grid`] = 'single';
        refs[`${this.component.key}-list-items-header`] = 'multiple';
        refs[`${this.component.key}-detail-control`] = 'multiple';
        this.loadRefs(element, refs);
        var args = this.evalContext(args);
        args.form = this.root;
        this.emit('requestAri', {
            com: this.component,
            url: this.interpolate(this.component.ariaction),
            aribody: {},
            resultType: null,
            script: (result) => {
                if (result.length > 0) {
                    this.formulaListFlat = result;
                    this.refs[`${this.component.key}-formulaList`].innerHTML = this.renderSelectGroup(result).join('');
                    this.getFormulaDitail();
                }
            },
            args: args
        });
        // Allow basic component functionality to attach like field logic and tooltips.
        this.addEventListener(this.refs[`${this.component.key}-input-search`], 'input', (e) => {
            this.debouncedFunction(e.target.value);
        });
        return super.attach(element);
    }
    updateValue(...args) {
        return this.updateComponentValue(...args);
    }
}
SimpleFormulaComponent.editForm = simpleformula_form_1.default;
SimpleFormulaComponent.builderInfo = {
    title: 'Simple formula',
    group: 'advanced',
    icon: 'th-list',
    weight: 70,
    documentation: 'http://help.ari.form/userguide/',
    schema: SimpleFormulaComponent.schema()
};
exports.default = SimpleFormulaComponent;
